export default __webpack_public_path__ + "static/media/18-spaceTurtle.d6c1d615.JPG";